import { AtomPlayButtonEvents } from 'wolf/components/atoms/a-play-button/a-play-button.events';
import ControllerBase from './../../../../global/js/ControllerBase';
import { MoleculeVideoOverlayEvents, MoleculeVideoOverlayEventTypes } from './m-video-overlay.events';


interface ComponentRefs {
	playButtonWrapper: 'playButtonWrapper',
}

export default class ControllerVideoOverlay extends ControllerBase<ComponentRefs> {
	private playButtonWrapper: HTMLDivElement;
	private playButton: HTMLButtonElement | null;

	constructor(element: HTMLElement) {
		super(element, [], [], true);

		// this.playButtonWrapper = this.$references.playButtonWrapper as HTMLDivElement;
		const ref: ComponentRefs['playButtonWrapper'] = 'playButtonWrapper';
		const exists = Array.from<HTMLDivElement>(this.$element.querySelectorAll('div[data-ref=' + ref + ']'));
		if (exists.length === 0) return;

		this.playButtonWrapper = exists[0];

		if (this.playButtonWrapper) {
			// find play button and lister for clicks
			const button = this.playButtonWrapper.querySelector<'button'>('button');
			this.playButton = button;
			this.observePlayButtonClick();
		}
	}

	private observePlayButtonClick(): void {

		this.playButton && this.playButton.addEventListener(AtomPlayButtonEvents.playButtonClicked, (event) => {
			this.dispatchCustomEvent<
			MoleculeVideoOverlayEventTypes['playButtonClicked']
			>(
				// play button was clicked in the atom
				MoleculeVideoOverlayEvents.playButtonClicked,
				true,
				true,
				false,
			);
		});
	}
}
